import { Fragment } from "react";

export default function Steps({ steps, cur }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "40px",
        gap: "8px",
        flexWrap: "wrap",
      }}
    >
      {steps.map((s, i) => (
        <Fragment key={s.n}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "50%",
                background:
                  cur >= s.n
                    ? "linear-gradient(135deg, #00d4aa 0%, #00a8cc 100%)"
                    : "rgba(255,255,255,0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "600",
                color: cur >= s.n ? "#0a0a0a" : "rgba(255,255,255,0.4)",
                transition: "all 0.3s",
                boxShadow:
                  cur >= s.n ? "0 4px 15px rgba(0, 212, 170, 0.3)" : "none",
              }}
            >
              {cur > s.n ? "✓" : s.n}
            </div>
            <span
              style={{
                fontSize: "12px",
                color: cur >= s.n ? "#00d4aa" : "rgba(255,255,255,0.4)",
                fontWeight: "500",
              }}
            >
              {s.l}
            </span>
          </div>
          {i < steps.length - 1 && (
            <div
              style={{
                width: "60px",
                height: "3px",
                background:
                  cur > s.n
                    ? "linear-gradient(135deg, #00d4aa 0%, #00a8cc 100%)"
                    : "rgba(255,255,255,0.1)",
                marginTop: "20px",
                borderRadius: "2px",
              }}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
}
